import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export enum LANGUAGES {
  EN = "en",
  JP = "jp",
}

export const useLanguageRedirect = () => {
  const navigate = useNavigate();

  // Default to EN if no language is set
  const language = localStorage.getItem("lang") || LANGUAGES.EN;

  useEffect(() => {
    const path = window.location.pathname;

    // EN → Normal routes (no /jp/)
    if (language === LANGUAGES.EN && !path.startsWith("/jp/")) return;

    // JP → Must always have /jp/ prefix
    if (language === LANGUAGES.JP && path.startsWith("/jp/")) return;

    let newPath = path;

    if (language === LANGUAGES.EN) {
      // Remove /jp/ for English
      newPath = path.replace("/jp/", "/");
    } else if (language === LANGUAGES.JP) {
      // Convert /en/ or / → JP path
      if (path.startsWith("/en/")) {
        newPath = path.replace("/en/", "/jp/");
      } else if (path === "/") {
        newPath = "/jp/";
      } else {
        newPath = `/jp${path}`;
      }
    }

    if (newPath !== path) {
      navigate(newPath);
      setTimeout(() => window.location.reload(), 100);
    }
  }, [language, navigate]);

  return {
    language,
  };
};
